// extracted by mini-css-extract-plugin
module.exports = {"ROW_ITEM_HEIGHT_SMALL":"6rem","ROW_ITEM_HEIGHT_DEFAULT":"9.8rem","ROW_ITEM_HEIGHT_LARGE":"13rem"};